import { useContext } from "react";
import { RetryPolicyContext } from "../context/RetryPolicyContext";

const useRetryPolicy = () => {
    const { executeWithRetry } = useContext(RetryPolicyContext);
    return { executeWithRetry };
};

export default useRetryPolicy;